import { entityAssignedToLocation, normalizeLocationIds } from './locationTypes';

export const filterServicesByLocation = (services = [], locationId) => {
  const normalizedLocationId = String(locationId || '').trim();
  if (!normalizedLocationId) return services;

  return services.filter((service) => entityAssignedToLocation(service, normalizedLocationId));
};

export const filterStaffByLocation = (staff = [], locationId) => {
  const normalizedLocationId = String(locationId || '').trim();
  if (!normalizedLocationId) return staff;

  return staff.filter((member) => entityAssignedToLocation(member, normalizedLocationId));
};

export const filterEmployeeIdsByLocation = (employeeIds = [], staff = [], locationId) => {
  const normalizedLocationId = String(locationId || '').trim();
  const normalizedEmployeeIds = normalizeLocationIds(employeeIds);
  if (!normalizedLocationId) return normalizedEmployeeIds;

  const staffById = new Map(staff.map((member) => [member.id, member]));
  return normalizedEmployeeIds.filter((employeeId) => {
    const member = staffById.get(employeeId);
    if (!member) return false;
    return entityAssignedToLocation(member, normalizedLocationId);
  });
};

export const shouldShowLocationStep = (locations = []) => {
  const activeLocations = locations.filter((location) => location.active !== false);
  return activeLocations.length > 1;
};

export const buildAppointmentLocationFields = (location) => {
  if (!location?.id) return {};

  return {
    locationId: location.id,
    locationName: location.name || '',
    locationAddress: location.address || null,
  };
};
